import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import BusinessIcon from '@mui/icons-material/Business';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {Link, useNavigate, useParams} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getBranchUsers} from "../store/logIn";
import {useEffect, useState} from "react";

// Viloyatga tegishli tashkilotlar ro'yxati
// URL: /branches/:viloyatId
function UnderBranches(props) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const viloyatId = params.viloyatId || ''

    const [branches, setBranches] = useState([])

    useEffect(() => {
        props.getBranchUsers(viloyatId)
    }, [viloyatId])

    useEffect(() => {
        setBranches(props.branch_users || [])
    }, [props.branch_users])

    const toBack = () => navigate(-1)

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title'}>{t('tashkilotlar')}</h2>
                        <div className="row">
                            {branches.length > 0 ? branches.map((item, index) => (
                                <div className="col-lg-2" key={index}>
                                    {/* Tashkilotga kirganda uning barcha bo'limlari */}
                                    <Link to={`/regions/branch/${item.id}`}>
                                        <div className="card">
                                            <div className="card-header">
                                                <BusinessIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>
                                                    {item.display_name || item.user_name}
                                                </h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className={'no-infos'}>{t('no_info')}</div>
                            )}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getBranchUsers})(UnderBranches)